import { Link } from "@quintype/components";
import React from "react";
import "./header-newsletter.m.css";
import Newsletter from "../other-icons/Newsletter";

function HeaderNewsletter() {
  return (
    <div styleName="wrapper">
      <Link target="_blank" href="https://www.deccanherald.com/newsletters" styleName="newsletter">
        Newsletters <Newsletter color="#E6B832" width="14px" height="14px" />
      </Link>
    </div>
  );
}

export default HeaderNewsletter;
